import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { numberTropicalizer } from '@navent-jobs/config'
import { MainContainer, Row, Col } from '@navent-jobs/ui-kit/components/grid'

// mixins
import { BannerContainer, BannerWrapperText, Title, SubTitle, Total } from './mixins'

// constants
import { SITE_ID } from '../../../../constants'
import settingsBanner from '../../../../constants/banner-landings'

// store
import {
  setFilterSettings,
  setFiltersDefault,
  setFiltersDeleteAll,
  setFiltersHide,
} from '../../../../redux/actions/filters'
import { ads, facetBanner as functionBanner, setActiveLanding } from '../../../../redux/actions/listado-avisos'

const actionPuestosEjecutivos = dispatch => {
  dispatch(setFilterSettings())
  dispatch(setActiveLanding('puestos-ejecutivos'))
  dispatch(
    setFiltersDefault({
      name: 'nivel_laboral',
      option: {
        label: 'Gerencia / Alta Gerencia / Dirección',
        value: 'gerencia-alta-gerencia-direccion',
      },
    })
  )
  dispatch(setFiltersDeleteAll(false))
  dispatch(setFiltersHide({ type: 'nivel_laboral' }))
  dispatch(
    functionBanner({
      enabled: settingsBanner[SITE_ID || 'BMAR']?.puestosEjecutivos?.enabled,
      title: settingsBanner[SITE_ID || 'BMAR']?.puestosEjecutivos?.title,
      bannerImage: settingsBanner[SITE_ID || 'BMAR']?.puestosEjecutivos?.imageListado,
    })
  )
  dispatch(ads(false))
}

const actionJovenesProfesionales = dispatch => {
  dispatch(setFilterSettings())
  dispatch(setActiveLanding('jovenes-profesionales'))
  dispatch(
    setFiltersDefault({
      name: 'nivel_laboral',
      option: {
        label: 'Junior',
        value: 'junior',
      },
    })
  )
  dispatch(setFiltersDeleteAll(false))
  dispatch(setFiltersHide({ type: 'nivel_laboral' }))
  dispatch(
    functionBanner({
      enabled: settingsBanner[SITE_ID || 'BMAR']?.jovenesProfesionales?.enabled,
      title: settingsBanner[SITE_ID || 'BMAR']?.jovenesProfesionales?.title,
      bannerImage: settingsBanner[SITE_ID || 'BMAR']?.jovenesProfesionales?.imageListado,
    })
  )
  dispatch(ads(false))
}

const actionEmpleosInclusivos = dispatch => {
  dispatch(setFilterSettings())
  dispatch(setActiveLanding('empleos-inclusivos'))
  dispatch(
    setFiltersDefault({
      name: 'apto_discapacitado',
      option: {
        label: 'true',
        value: 'true',
      },
    })
  )
  dispatch(setFiltersDeleteAll(false))
  dispatch(setFiltersHide({ type: 'apto_discapacitado' }))
  dispatch(
    functionBanner({
      enabled: settingsBanner[SITE_ID || 'BMAR']?.empleosInclusivos?.enabled,
      title: settingsBanner[SITE_ID || 'BMAR']?.empleosInclusivos?.title,
      bannerImage: settingsBanner[SITE_ID || 'BMAR']?.empleosInclusivos?.imageListado,
    })
  )
  dispatch(ads(false))
}

const actionEmpleosPartTime = dispatch => {
  dispatch(setFilterSettings())
  dispatch(setActiveLanding('empleos-part-time'))
  dispatch(
    setFiltersDefault({
      name: 'tipo_trabajo',
      option: {
        label: 'part-time',
        value: 'part-time',
      },
    })
  )
  dispatch(setFiltersDeleteAll(false))
  dispatch(setFiltersHide({ type: 'tipo_trabajo' }))
  dispatch(
    functionBanner({
      enabled: settingsBanner[SITE_ID || 'BMAR']?.partTime?.enabled,
      title: settingsBanner[SITE_ID || 'BMAR']?.partTime?.title,
      bannerImage: settingsBanner[SITE_ID || 'BMAR']?.partTime?.imageListado,
    })
  )
  dispatch(ads(false))
}

const actionPracticasProfesionales = dispatch => {
  dispatch(setFilterSettings())
  dispatch(setActiveLanding('practicas-profesionales'))
  dispatch(
    setFiltersDefault({
      name: 'tipo_trabajo',
      option: {
        label: 'pasantia',
        value: 'pasantia',
      },
    })
  )
  dispatch(setFiltersDeleteAll(false))
  dispatch(setFiltersHide({ type: 'tipo_trabajo' }))
  dispatch(
    functionBanner({
      enabled: settingsBanner[SITE_ID || 'BMAR']?.practicasProfesionales?.enabled,
      title: settingsBanner[SITE_ID || 'BMAR']?.practicasProfesionales?.title,
      bannerImage: settingsBanner[SITE_ID || 'BMAR']?.practicasProfesionales?.imageListado,
    })
  )
  dispatch(ads(false))
}

interface BannerWithFilterProps {
  h1?: string | null
  preh1?: string | null
  grandTotal: number
  totalAvisos: number
  loading: boolean
  facetBanner: {
    enabled: boolean
    title: string
    bannerImage: string
  }
}

const BannerWithFilter = ({ h1, preh1, loading, grandTotal, totalAvisos, facetBanner }: BannerWithFilterProps) => {
  const dispatch = useDispatch()
  const [bannerPosition, setBannerPosition] = useState('center')

  useEffect(() => {
    if (window.location.search.includes('landing-puestos-ejecutivos=true')) {
      actionPuestosEjecutivos(dispatch)
    }
    if (window.location.search.includes('landing-jovenes-profesionales=true')) {
      actionJovenesProfesionales(dispatch)
    }
    if (window.location.search.includes('landing-empleos-inclusivos=true')) {
      setBannerPosition('right')
      actionEmpleosInclusivos(dispatch)
    }
    if (window.location.search.includes('landing-empleos-part-time=true')) {
      setBannerPosition('right')
      actionEmpleosPartTime(dispatch)
    }
    if (window.location.search.includes('landing-practicas-profesionales=true')) {
      setBannerPosition('center')
      actionPracticasProfesionales(dispatch)
    }
  }, [window.location.search])

  if (!facetBanner.enabled) {
    return null
  }

  return (
    <BannerContainer position={bannerPosition} image={facetBanner.bannerImage}>
      <MainContainer>
        <Row>
          <Col>
            <BannerWrapperText>
              <Title>{facetBanner.title}</Title>
              <SubTitle>
                {preh1 ? `${preh1} ` : undefined}
                <Total>{!loading && numberTropicalizer(grandTotal || totalAvisos)} </Total>
                {loading ? 'Buscando ofertas de empleo...' : h1}
              </SubTitle>
            </BannerWrapperText>
          </Col>
        </Row>
      </MainContainer>
    </BannerContainer>
  )
}

const states = ({ listadoAvisosStore }) => {
  const { totalAvisos, grandTotal, loading, facetBanner, seoWordings } = listadoAvisosStore
  const { h1, preh1 } = seoWordings
  return {
    totalAvisos,
    grandTotal,
    loading,
    facetBanner,
    h1,
    preh1,
  }
}

export default connect(states)(BannerWithFilter)
